import React from 'react';
export const Footer = ()=>{
    return(
        <div className='footer' id='footer'>
           ©Copyright and All right reserved 
        </div>
    );
}